<template lang="pug">
div(style="margin-top: -24px;margin-left: -15px;margin-right: -15px;")
  #ConsumoIA
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12, md12, sm12)
        v-card(style="border-radius:5px;background-color: white;")
          v-card-title(style='padding: 8px !important;').justify-center
            img(src='../assets/logo.png', style='height: auto;width: 140px;')
        v-card(style="border-radius:5px;background-color: black")
          v-card-title(style="padding: 7px;").justify-center
            span.white--text Consumo y Costo de IA por Vendedor

    //- Tarjetas de Resumen General
    v-layout(row wrap style="padding: 12px 10px 4px 10px;")
      v-flex(xs12 sm4 style="padding: 6px;")
        v-card(style="border-radius: 10px; background: #1e293b; color: white; padding: 14px 18px;")
          div(style="font-size: 12px; color: #94a3b8; font-weight: 600; text-transform: uppercase;") Total Consultas IA ({{ etiquetaPeriodoActual }})
          div(style="font-size: 26px; font-weight: bold; margin-top: 4px;") {{ formatoEntero(totales.peticiones) }}
          div(style="font-size: 11px; color: #cbd5e1; margin-top: 2px;") En el período seleccionado
      v-flex(xs12 sm4 style="padding: 6px;")
        v-card(style="border-radius: 10px; background: #0f172a; color: white; padding: 14px 18px;")
          div(style="font-size: 12px; color: #94a3b8; font-weight: 600; text-transform: uppercase;") Total Tokens Consumidos ({{ etiquetaPeriodoActual }})
          div(style="font-size: 26px; font-weight: bold; color: #38bdf8; margin-top: 4px;") {{ formatoEntero(totales.total_tokens) }}
          div(style="font-size: 11px; color: #cbd5e1; margin-top: 2px;") Entrada: {{ formatoEntero(totales.prompt_tokens) }} | Salida: {{ formatoEntero(totales.completion_tokens) }}
      v-flex(xs12 sm4 style="padding: 6px;")
        v-card(style="border-radius: 10px; background: #064e3b; color: white; padding: 14px 18px;")
          div(style="font-size: 12px; color: #a7f3d0; font-weight: 600; text-transform: uppercase;") Costo Total Estimado USD ({{ etiquetaPeriodoActual }})
          div(style="font-size: 26px; font-weight: bold; color: #34d399; margin-top: 4px;") ${{ formatoCosto(totales.costo_total) }}
          div(style="font-size: 11px; color: #d1fae5; margin-top: 2px;") Acumulado de todos los vendedores

    //- Filtros
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12 style='margin-top: 5px;')
        v-layout(wrap style='justify-content: space-between; align-items: center; padding: 0 10px;')
          v-flex(xs12 sm3)
            v-text-field(v-model='search', label='Buscar vendedor, código o cliente', prepend-inner-icon="search" clearable)
          v-flex(xs12 sm2 style='padding-left:12px;')
            v-menu(ref='menuMes' v-model='menuMes' :close-on-content-click='false' transition='scale-transition' offset-y max-width='290px' min-width='290px')
              template(v-slot:activator='{ on }')
                v-text-field(:value='mesSeleccionadoTexto' label='Mes de Consumo' prepend-inner-icon="event" readonly v-on='on' clearable @click:clear="verTodosLosMeses")
              v-date-picker(v-model='filtroMes' type='month' locale='es' no-title dark @input='alSeleccionarMes')
                v-btn(flat small color='primary' @click='seleccionarMesActual') Este Mes
                v-spacer
                v-btn(flat small color='grey' @click='verTodosLosMeses') Todos
          v-flex(xs12 sm2 style='padding-left:12px;')
            v-select(:items='modulosOpciones' v-model="filtroModulo" label="Módulo" @change='cargarLogs()')
          v-flex(xs12 sm2 style='padding-left:12px;')
            v-menu(ref='menuFecha' v-model='menuFecha' :close-on-content-click='false' transition='scale-transition' offset-y max-width='320px' min-width='320px')
              template(v-slot:activator='{ on }')
                v-text-field(v-model='fechaRangoTexto' label='Rango de Fechas Exacto' prepend-inner-icon="date_range" readonly v-on='on' clearable @click:clear="limpiarFechas")
              v-date-picker(multiple v-model='fechas' no-title dark)
                v-btn(flat small color='primary' @click='seleccionarHoy') Hoy
                v-spacer
                v-btn(flat small color='grey' @click='limpiarFechas(); menuFecha = false') Limpiar
                v-btn(flat small color='primary' @click='menuFecha = false; filtroMes = ""; cargarLogs()') OK
          v-flex(xs12 sm3 style='display: flex; justify-content: flex-end; align-items: center; gap: 12px;')
            v-btn(color="primary" dark style="border-radius: 8px;" @click="cargarLogs" :loading="loading")
              v-icon(left) refresh
              | Actualizar
            vue-excel-xlsx(
              v-if="dataExcelVendedores && dataExcelVendedores.length > 0"
              :data="dataExcelVendedores"
              :columns="columnsExcelVendedores"
              :filename="'Fercoven-Consumo-IA-Vendedores'"
              :sheetname="'Por Vendedor'"
              style="cursor: pointer;"
              title="Descargar Resumen por Vendedor en Excel"
            )
              div(style="display: flex; flex-direction: column; font-size: 11px; font-weight: bold; text-align: center; align-items: center;")
                img(src="../assets/iconos/excel.png" style="height: 44px; width: auto;")
                span Por Vendedor

        //- Tabla 0: Resumen de Consumo por Mes
        v-card(style="border-radius: 0px 0px 20px 20px; background-color: #0f172a; margin-top: 10px;")
          v-card-title(style="padding: 7px;").justify-center
            span.white--text Resumen de Consumo y Costo por Mes

        v-data-table.elevation-1(
          :headers='headersMeses'
          :items='porMes'
          :loading='loading'
          :pagination.sync="paginationMeses"
          style="margin-top: 5px;"
        )
          template(slot='items', slot-scope='props')
            tr(
              :style="filtroMes === props.item.mes ? 'background-color: #e0f2fe; cursor: pointer;' : 'cursor: pointer;'"
              @click="filtrarPorFilaMes(props.item.mes)"
              title="Haz clic para filtrar el consumo de este mes"
            )
              td.text-xs-center(style="font-weight: bold; color: #0284c7;")
                v-icon(small color="primary" v-if="filtroMes === props.item.mes" style="margin-right: 4px;") check_circle
                | {{ formatearMesNombre(props.item.mes) }}
              td.text-xs-center(style="font-weight: 600;") {{ formatoEntero(props.item.vendedores_activos) }}
              td.text-xs-center(style="font-weight: bold;") {{ formatoEntero(props.item.peticiones) }}
              td.text-xs-center {{ formatoEntero(props.item.cobros_peticiones) }}
              td.text-xs-center {{ formatoEntero(props.item.retenciones_peticiones) }}
              td.text-xs-center {{ formatoEntero(props.item.productos_peticiones) }}
              td.text-xs-center {{ formatoEntero(props.item.prompt_tokens) }}
              td.text-xs-center {{ formatoEntero(props.item.completion_tokens) }}
              td.text-xs-center(style="font-weight: bold; color: #0369a1;") {{ formatoEntero(props.item.total_tokens) }}
              td.text-xs-center(style="font-weight: bold; color: #059669; font-size: 14px;") ${{ formatoCosto(props.item.costo_total) }}

        //- Tabla 1: Resumen de Consumo por Vendedor
        v-card(style="border-radius: 0px 0px 20px 20px; background-color: black; margin-top: 20px;")
          v-card-title(style="padding: 7px;").justify-center
            span.white--text Resumen de Consumo y Costo por Vendedor ({{ etiquetaPeriodoActual }}) — Haz clic en un vendedor para ver su historial detallado

        v-data-table.elevation-1(
          :headers='headersVendedores'
          :items='porVendedor'
          :loading='loading'
          :search='search'
          :pagination.sync="paginationVendedores"
          style="margin-top: 5px;"
        )
          template(slot='items', slot-scope='props')
            tr(
              style="cursor: pointer;"
              @click="abrirDetalleVendedor(props.item)"
              title="Haz clic para ver el historial detallado de este vendedor"
            )
              td.text-xs-center(style="font-weight: bold; color: #0284c7;") {{ props.item.co_ven || 'N/A' }}
              td.text-xs-left(style="font-weight: 600;") {{ props.item.ven_des || 'Sin nombre' }}
              td.text-xs-center(style="font-weight: bold;") {{ formatoEntero(props.item.peticiones) }}
              td.text-xs-center {{ formatoEntero(props.item.cobros_peticiones) }}
              td.text-xs-center {{ formatoEntero(props.item.retenciones_peticiones) }}
              td.text-xs-center {{ formatoEntero(props.item.productos_peticiones) }}
              td.text-xs-center {{ formatoEntero(props.item.prompt_tokens) }}
              td.text-xs-center {{ formatoEntero(props.item.completion_tokens) }}
              td.text-xs-center(style="font-weight: bold; color: #0369a1;") {{ formatoEntero(props.item.total_tokens) }}
              td.text-xs-center(style="font-weight: bold; color: #059669; font-size: 14px;") ${{ formatoCosto(props.item.costo_total) }}
              td.text-xs-center {{ formatearFecha(props.item.ultima_fecha) }}
              td.text-xs-center
                v-btn(flat icon small color="primary" @click.stop="abrirDetalleVendedor(props.item)" title="Ver historial detallado")
                  v-icon visibility

    //- Modal: Historial Detallado por Vendedor
    v-dialog(v-model="dialogDetalleVendedor" max-width="1150px" scrollable)
      v-card(v-if="vendedorSeleccionado" style="border-radius: 10px;")
        v-card-title(style="background-color: #0f172a; color: white; padding: 12px 20px; display: flex; justify-content: space-between; align-items: center;")
          div
            div(style="font-size: 16px; font-weight: bold;")
              | Historial Detallado de IA — {{ vendedorSeleccionado.co_ven }} ({{ vendedorSeleccionado.ven_des || 'Sin nombre' }})
            div(style="font-size: 12px; color: #94a3b8; margin-top: 2px;")
              | Período: {{ etiquetaPeriodoActual }} | Consultas: {{ formatoEntero(vendedorSeleccionado.peticiones) }} | Tokens: {{ formatoEntero(vendedorSeleccionado.total_tokens) }} | Costo Total: ${{ formatoCosto(vendedorSeleccionado.costo_total) }}
          v-btn(icon dark @click="dialogDetalleVendedor = false")
            v-icon close

        v-card-text(style="padding: 16px;")
          v-layout(row wrap align-center style="margin-bottom: 10px;")
            v-flex(xs12 sm6)
              v-text-field(
                v-model="searchDetalleVendedor"
                label="Buscar por cliente, módulo o fecha"
                prepend-inner-icon="search"
                clearable
                hide-details
              )
            v-flex(xs12 sm6 style="text-align: right; color: #475569; font-size: 13px;")
              span Mostrando {{ logsVendedorSeleccionado.length }} registros de este vendedor

          v-data-table.elevation-1(
            :headers='headersDetalle'
            :items='logsVendedorSeleccionado'
            :loading='loadingDetalleVendedor'
            :search='searchDetalleVendedor'
            :pagination.sync="paginationDetalle"
            style="margin-top: 8px;"
          )
            template(slot='items', slot-scope='props')
              td.text-xs-center {{ formatearFecha(props.item.fecha) }}
              td.text-xs-left {{ props.item.cliente && props.item.cliente.cli_des ? (props.item.cliente.co_cli + ' - ' + props.item.cliente.cli_des) : 'N/A' }}
              td.text-xs-center
                v-chip(small :color="colorModulo(props.item.modulo)" text-color="white") {{ props.item.modulo }}
              td.text-xs-center {{ props.item.modelo || 'google/gemini-2.5-flash' }}
              td.text-xs-center {{ formatoEntero(props.item.prompt_tokens) }}
              td.text-xs-center {{ formatoEntero(props.item.completion_tokens) }}
              td.text-xs-center(style="font-weight: bold;") {{ formatoEntero(props.item.total_tokens) }}
              td.text-xs-center(style="font-weight: bold; color: #059669;") ${{ formatoCosto(props.item.costo) }}

        v-card-actions(style="padding: 10px 20px; background: #f8fafc;")
          v-spacer
          v-btn(color="error" dark small @click="dialogDetalleVendedor = false")
            v-icon(left small) close
            | Cerrar
</template>

<script>
import Api from "@/services/methods";
import moment from "moment";

export default {
  name: "ConsumoIA",
  data: () => ({
    loading: false,
    search: "",
    filtroModulo: "Todos",
    modulosOpciones: [
      "Todos",
      "Cobros Fercoven",
      "Retenciones Fercoven",
      "Productos Fercoven"
    ],
    menuMes: false,
    filtroMes: moment().format("YYYY-MM"),
    menuFecha: false,
    fechas: [],
    logs: [],
    porMes: [],
    porVendedor: [],
    porModulo: [],
    dialogDetalleVendedor: false,
    vendedorSeleccionado: null,
    searchDetalleVendedor: "",
    loadingDetalleVendedor: false,
    logsVendedorSeleccionado: [],
    totales: {
      peticiones: 0,
      prompt_tokens: 0,
      completion_tokens: 0,
      total_tokens: 0,
      costo_total: 0
    },
    paginationMeses: {
      sortBy: "mes",
      descending: true,
      rowsPerPage: 12
    },
    paginationVendedores: {
      sortBy: "costo_total",
      descending: true,
      rowsPerPage: 15
    },
    paginationDetalle: {
      sortBy: "fecha",
      descending: true,
      rowsPerPage: 25
    },
    headersMeses: [
      { text: "Mes", value: "mes", align: "center" },
      { text: "Vendedores Activos", value: "vendedores_activos", align: "center" },
      { text: "Consultas Totales", value: "peticiones", align: "center" },
      { text: "Cobros", value: "cobros_peticiones", align: "center" },
      { text: "Retenciones", value: "retenciones_peticiones", align: "center" },
      { text: "Productos", value: "productos_peticiones", align: "center" },
      { text: "Tokens Entrada", value: "prompt_tokens", align: "center" },
      { text: "Tokens Salida", value: "completion_tokens", align: "center" },
      { text: "Tokens Totales", value: "total_tokens", align: "center" },
      { text: "Costo Mensual (USD)", value: "costo_total", align: "center" }
    ],
    headersVendedores: [
      { text: "Cód. Vendedor", value: "co_ven", align: "center" },
      { text: "Vendedor", value: "ven_des", align: "left" },
      { text: "Consultas Totales", value: "peticiones", align: "center" },
      { text: "Cobros", value: "cobros_peticiones", align: "center" },
      { text: "Retenciones", value: "retenciones_peticiones", align: "center" },
      { text: "Productos", value: "productos_peticiones", align: "center" },
      { text: "Tokens Entrada", value: "prompt_tokens", align: "center" },
      { text: "Tokens Salida", value: "completion_tokens", align: "center" },
      { text: "Tokens Totales", value: "total_tokens", align: "center" },
      { text: "Costo Total (USD)", value: "costo_total", align: "center" },
      { text: "Último Uso", value: "ultima_fecha", align: "center" },
      { text: "Historial", value: "acciones", align: "center", sortable: false }
    ],
    headersDetalle: [
      { text: "Fecha / Hora", value: "fecha", align: "center" },
      { text: "Cliente", value: "cliente.cli_des", align: "left" },
      { text: "Módulo (App)", value: "modulo", align: "center" },
      { text: "Modelo", value: "modelo", align: "center" },
      { text: "Tokens Entrada", value: "prompt_tokens", align: "center" },
      { text: "Tokens Salida", value: "completion_tokens", align: "center" },
      { text: "Tokens Totales", value: "total_tokens", align: "center" },
      { text: "Costo (USD)", value: "costo", align: "center" }
    ],
    columnsExcelVendedores: [
      { label: "Período / Mes", field: "mes_periodo" },
      { label: "Código Vendedor", field: "co_ven" },
      { label: "Vendedor", field: "ven_des" },
      { label: "Total Consultas", field: "peticiones" },
      { label: "Consultas Cobros", field: "cobros_peticiones" },
      { label: "Consultas Retenciones", field: "retenciones_peticiones" },
      { label: "Consultas Productos", field: "productos_peticiones" },
      { label: "Tokens Entrada", field: "prompt_tokens" },
      { label: "Tokens Salida", field: "completion_tokens" },
      { label: "Tokens Totales", field: "total_tokens" },
      { label: "Costo Total (USD)", field: "costo_formateado" },
      { label: "Último Uso", field: "ultima_fecha_formateada" }
    ]
  }),
  computed: {
    mesSeleccionadoTexto() {
      if (!this.filtroMes) return "Todos los meses";
      return this.formatearMesNombre(this.filtroMes);
    },
    etiquetaPeriodoActual() {
      if (this.fechas && this.fechas.length > 0) {
        return this.fechaRangoTexto;
      }
      if (this.filtroMes) {
        return this.formatearMesNombre(this.filtroMes);
      }
      return "Todos los meses";
    },
    fechaRangoTexto() {
      if (!this.fechas || this.fechas.length === 0) return "";
      const ordenadas = [...this.fechas].sort();
      if (ordenadas.length === 1) {
        return moment(ordenadas[0]).format("DD/MM/YYYY");
      }
      return `${moment(ordenadas[0]).format("DD/MM/YYYY")} - ${moment(ordenadas[ordenadas.length - 1]).format("DD/MM/YYYY")}`;
    },
    dataExcelVendedores() {
      return (this.porVendedor || []).map(v => ({
        ...v,
        mes_periodo: this.etiquetaPeriodoActual,
        costo_formateado: (Number(v.costo_total || 0) * 1.4).toFixed(6),
        ultima_fecha_formateada: this.formatearFecha(v.ultima_fecha)
      }));
    }
  },
  created() {
    this.cargarLogs();
  },
  methods: {
    alSeleccionarMes() {
      this.menuMes = false;
      this.fechas = [];
      this.cargarLogs();
    },
    seleccionarMesActual() {
      this.filtroMes = moment().format("YYYY-MM");
      this.fechas = [];
      this.menuMes = false;
      this.cargarLogs();
    },
    verTodosLosMeses() {
      this.filtroMes = "";
      this.menuMes = false;
      this.cargarLogs();
    },
    filtrarPorFilaMes(mes) {
      if (this.filtroMes === mes) {
        this.filtroMes = "";
      } else {
        this.filtroMes = mes;
      }
      this.fechas = [];
      this.cargarLogs();
    },
    seleccionarHoy() {
      const hoy = moment().format("YYYY-MM-DD");
      this.fechas = [hoy];
      this.filtroMes = "";
      this.menuFecha = false;
      this.cargarLogs();
    },
    limpiarFechas() {
      this.fechas = [];
      this.cargarLogs();
    },
    async abrirDetalleVendedor(vendedor) {
      if (!vendedor) return;
      this.vendedorSeleccionado = vendedor;
      this.searchDetalleVendedor = "";
      const coVen = String(vendedor.co_ven || "").trim();
      this.logsVendedorSeleccionado = (this.logs || []).filter(
        l => String(l.co_ven || "").trim() === coVen
      );
      this.dialogDetalleVendedor = true;

      if (!coVen || coVen === "SIN_CODIGO") return;
      this.loadingDetalleVendedor = true;
      try {
        const params = [`co_ven=${encodeURIComponent(coVen)}`, "limit=1000"];
        if (this.filtroModulo && this.filtroModulo !== "Todos") {
          params.push(`modulo=${encodeURIComponent(this.filtroModulo)}`);
        }
        if (this.fechas && this.fechas.length > 0) {
          const ordenadas = [...this.fechas].sort();
          params.push(`desde=${ordenadas[0]}`);
          params.push(`hasta=${ordenadas[ordenadas.length - 1]}`);
        } else if (this.filtroMes && /^\d{4}-\d{2}$/.test(this.filtroMes)) {
          const inicioMes = moment(this.filtroMes, "YYYY-MM")
            .startOf("month")
            .format("YYYY-MM-DD");
          const finMes = moment(this.filtroMes, "YYYY-MM")
            .endOf("month")
            .format("YYYY-MM-DD");
          params.push(`mes=${this.filtroMes}`);
          params.push(`desde=${inicioMes}`);
          params.push(`hasta=${finMes}`);
        }
        const res = await Api.get(`iaLogs?${params.join("&")}`);
        if (res && res.data && Array.isArray(res.data.data)) {
          this.logsVendedorSeleccionado = res.data.data;
        }
      } catch (err) {
        console.error("Error cargando detalle del vendedor:", err);
      } finally {
        this.loadingDetalleVendedor = false;
      }
    },
    calcularPorMesDesdeLogs(listaLogs) {
      const mapa = {};
      (listaLogs || []).forEach(item => {
        const m = item.fecha
          ? moment(item.fecha).utc().format("YYYY-MM")
          : "Sin fecha";
        if (!mapa[m]) {
          mapa[m] = {
            mes: m,
            vendedoresSet: new Set(),
            peticiones: 0,
            cobros_peticiones: 0,
            retenciones_peticiones: 0,
            productos_peticiones: 0,
            prompt_tokens: 0,
            completion_tokens: 0,
            total_tokens: 0,
            costo_total: 0
          };
        }
        const grupo = mapa[m];
        if (item.co_ven) grupo.vendedoresSet.add(item.co_ven);
        grupo.peticiones += 1;
        if (item.modulo === "Cobros Fercoven") grupo.cobros_peticiones += 1;
        if (item.modulo === "Retenciones Fercoven") grupo.retenciones_peticiones += 1;
        if (item.modulo === "Productos Fercoven") grupo.productos_peticiones += 1;
        grupo.prompt_tokens += Number(item.prompt_tokens) || 0;
        grupo.completion_tokens += Number(item.completion_tokens) || 0;
        grupo.total_tokens += Number(item.total_tokens) || 0;
        grupo.costo_total += Number(item.costo) || 0;
      });
      return Object.values(mapa)
        .map(g => ({
          mes: g.mes,
          vendedores_activos: g.vendedoresSet.size,
          peticiones: g.peticiones,
          cobros_peticiones: g.cobros_peticiones,
          retenciones_peticiones: g.retenciones_peticiones,
          productos_peticiones: g.productos_peticiones,
          prompt_tokens: g.prompt_tokens,
          completion_tokens: g.completion_tokens,
          total_tokens: g.total_tokens,
          costo_total: g.costo_total
        }))
        .sort((a, b) => (a.mes < b.mes ? 1 : -1));
    },
    async cargarLogs() {
      this.loading = true;
      try {
        const params = [];
        const paramsGlobalMeses = [];
        if (this.filtroModulo && this.filtroModulo !== "Todos") {
          const modParam = `modulo=${encodeURIComponent(this.filtroModulo)}`;
          params.push(modParam);
          paramsGlobalMeses.push(modParam);
        }
        if (this.fechas && this.fechas.length > 0) {
          const ordenadas = [...this.fechas].sort();
          params.push(`desde=${ordenadas[0]}`);
          params.push(`hasta=${ordenadas[ordenadas.length - 1]}`);
        } else if (this.filtroMes && /^\d{4}-\d{2}$/.test(this.filtroMes)) {
          const inicioMes = moment(this.filtroMes, "YYYY-MM")
            .startOf("month")
            .format("YYYY-MM-DD");
          const finMes = moment(this.filtroMes, "YYYY-MM")
            .endOf("month")
            .format("YYYY-MM-DD");
          params.push(`mes=${this.filtroMes}`);
          params.push(`desde=${inicioMes}`);
          params.push(`hasta=${finMes}`);
        }
        params.push("limit=1000");
        paramsGlobalMeses.push("limit=2000");

        const query = params.length > 0 ? `?${params.join("&")}` : "";
        const queryGlobal = paramsGlobalMeses.length > 0 ? `?${paramsGlobalMeses.join("&")}` : "";

        const [res, resGlobal] = await Promise.all([
          Api.get(`iaLogs${query}`),
          this.filtroMes || (this.fechas && this.fechas.length > 0)
            ? Api.get(`iaLogs${queryGlobal}`)
            : Promise.resolve(null)
        ]);

        if (res && res.data) {
          this.logs = res.data.data || [];
          this.porVendedor = res.data.porVendedor || [];
          this.porModulo = res.data.porModulo || [];
          this.totales = res.data.totales || {
            peticiones: 0,
            prompt_tokens: 0,
            completion_tokens: 0,
            total_tokens: 0,
            costo_total: 0
          };

          const fuenteGlobal = resGlobal && resGlobal.data ? resGlobal.data : res.data;
          if (fuenteGlobal.porMes && fuenteGlobal.porMes.length > 0) {
            this.porMes = fuenteGlobal.porMes;
          } else {
            this.porMes = this.calcularPorMesDesdeLogs(fuenteGlobal.data || this.logs);
          }
        }
      } catch (err) {
        console.error("Error cargando logs de IA:", err);
      } finally {
        this.loading = false;
      }
    },
    formatearMesNombre(mesStr) {
      if (!mesStr || !/^\d{4}-\d{2}$/.test(mesStr)) return mesStr || "-";
      const nombres = [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre"
      ];
      const [anio, mes] = mesStr.split("-");
      const idx = parseInt(mes, 10) - 1;
      return `${nombres[idx] || mes} ${anio}`;
    },
    formatoEntero(val) {
      const n = Number(val) || 0;
      return n.toLocaleString("es-VE");
    },
    formatoCosto(val) {
      const n = (Number(val) || 0) * 1.4;
      return n.toFixed(5);
    },
    formatearFecha(f) {
      if (!f) return "-";
      return moment(f).utc().format("DD/MM/YYYY hh:mm A");
    },
    colorModulo(mod) {
      if (mod === "Cobros Fercoven") return "#0284c7";
      if (mod === "Retenciones Fercoven") return "#7c3aed";
      if (mod === "Productos Fercoven") return "#059669";
      return "#475569";
    }
  }
};
</script>

